<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    disagree-text="dialog.disagreeClose"
    :is-agree-visible="false"
    :title="$i18n.t('dialog.title.qgis')"
  >
    <template #body>
      <div class="pa-6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap text-left text-body-2">
                <i18n path="dialog.body.qgis_1" tag="span">
                  <template #link>
                    <a target="_blank" :href="repositoryUrl">{{ repositoryUrl }}</a>
                  </template>
                </i18n>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap text-left  text-body-2">
                <div v-html="qgisPluginInfoContent" />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </template>
  </main-large-dialog>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'QgisPluginDialog',
  components: {
    MainLargeDialog: () => import('@/components/MainLargeDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    repositoryUrl: `${process.env.VUE_APP_API_URL}/qgis_plugins/repository`,
  }),
  computed: {
    qgisPluginInfoContent: get('admin/settingsValues@qgis_plugin_info_content_enabled'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
};
</script>
